[
  {
    "id": "classic-brown",
    "category": "crafting-table",
    "name": "Classic Brown",
    "rarity": "starter",
    "coinPrice": 0,
    "slotTexturePath": "/fallback/cosmetics/crafting-table-slots/classic-brown.png",
    "creator": "LithiumSound and Team SummerFields",
    "license": "CC BY-NC-SA 4.0",
    "sourceUrl": "https://github.com/SummerFields/SummerFields",
    "tablePalette": {
      "surface": "#8a5a32",
      "edge": "#4d2f19",
      "highlight": "#d6a96a",
      "accent": "#71bd46",
      "label": "#2c1d13"
    }
  },
  {
    "id": "ocean-blue",
    "category": "crafting-table",
    "name": "Ocean Blue",
    "rarity": "uncommon",
    "coinPrice": 275,
    "slotTexturePath": "/fallback/cosmetics/crafting-table-slots/ocean-blue.png",
    "creator": "Kenney",
    "license": "CC0 1.0",
    "sourceUrl": "https://opengameart.org/content/ui-pack-pixel-adventure",
    "tablePalette": {
      "surface": "#3f6785",
      "edge": "#20384d",
      "highlight": "#79a9cc",
      "accent": "#65c8e8",
      "label": "#f3fbff"
    }
  },
  {
    "id": "sunset-orange",
    "category": "crafting-table",
    "name": "Sunset Orange",
    "rarity": "uncommon",
    "coinPrice": 300,
    "slotTexturePath": "/fallback/cosmetics/crafting-table-slots/sunset-orange.png",
    "creator": "Kenney",
    "license": "CC0 1.0",
    "sourceUrl": "https://opengameart.org/content/ui-pack-pixel-adventure",
    "tablePalette": {
      "surface": "#a45b32",
      "edge": "#553019",
      "highlight": "#e6a166",
      "accent": "#ffcc5b",
      "label": "#2f1b0f"
    }
  },
  {
    "id": "slate-gray",
    "category": "crafting-table",
    "name": "Slate Gray",
    "rarity": "rare",
    "coinPrice": 475,
    "slotTexturePath": "/fallback/cosmetics/crafting-table-slots/slate-gray.png",
    "creator": "maxhacker11",
    "license": "CC0 1.0",
    "sourceUrl": "https://opengameart.org/content/inventory-starter-pack",
    "tablePalette": {
      "surface": "#565d65",
      "edge": "#292e33",
      "highlight": "#9ba2aa",
      "accent": "#c1ced8",
      "label": "#f6f8fa"
    }
  },
  {
    "id": "amethyst-purple",
    "category": "crafting-table",
    "name": "Amethyst Purple",
    "rarity": "epic",
    "coinPrice": 700,
    "slotTexturePath": "/fallback/cosmetics/crafting-table-slots/amethyst-purple.png",
    "creator": "Kenney",
    "license": "CC0 1.0",
    "sourceUrl": "https://opengameart.org/content/ui-pack-pixel-adventure",
    "tablePalette": {
      "surface": "#675080",
      "edge": "#342641",
      "highlight": "#a98fc1",
      "accent": "#ca8cff",
      "label": "#fbf6ff"
    }
  },
  {
    "id": "obsidian-black",
    "category": "crafting-table",
    "name": "Obsidian Black",
    "rarity": "epic",
    "coinPrice": 800,
    "slotTexturePath": "/fallback/cosmetics/crafting-table-slots/obsidian-black.png",
    "creator": "Cethiel",
    "license": "CC0 1.0",
    "sourceUrl": "https://opengameart.org/content/inventory",
    "tablePalette": {
      "surface": "#2e2837",
      "edge": "#121016",
      "highlight": "#625873",
      "accent": "#9b6ac7",
      "label": "#f4edff"
    }
  },
  {
    "id": "gravel",
    "category": "crafting-table",
    "name": "Gravel",
    "rarity": "uncommon",
    "coinPrice": 250,
    "slotTexturePath": "/fallback/cosmetics/crafting-table-slots/gravel.png",
    "creator": "Liu_Sicen",
    "license": "MIT",
    "sourceUrl": "https://modrinth.com/resourcepack/modern_gui%2B%2B",
    "tablePalette": {
      "surface": "#5b5650",
      "edge": "#282626",
      "highlight": "#ada592",
      "accent": "#608355",
      "label": "#f7f4ed"
    }
  },
  {
    "id": "x-glass",
    "category": "crafting-table",
    "name": "X Glass",
    "rarity": "epic",
    "coinPrice": 750,
    "slotTexturePath": "/fallback/cosmetics/crafting-table-slots/x-glass.png",
    "creator": "Tantosy",
    "license": "MIT",
    "sourceUrl": "https://modrinth.com/resourcepack/glassyui",
    "tablePalette": {
      "surface": "#4f636a",
      "edge": "#232a30",
      "highlight": "#a7ab9e",
      "accent": "#568d69",
      "label": "#f7f4ed"
    }
  },
  {
    "id": "window-pane",
    "category": "crafting-table",
    "name": "Window Pane",
    "rarity": "rare",
    "coinPrice": 500,
    "slotTexturePath": "/fallback/cosmetics/crafting-table-slots/window-pane.png",
    "creator": "Tantosy",
    "license": "MIT",
    "sourceUrl": "https://modrinth.com/resourcepack/glassyui",
    "tablePalette": {
      "surface": "#4f636a",
      "edge": "#232a30",
      "highlight": "#a7ab9e",
      "accent": "#568d69",
      "label": "#f7f4ed"
    }
  },
  {
    "id": "stone-cold",
    "category": "crafting-table",
    "name": "Stone Cold",
    "rarity": "rare",
    "coinPrice": 500,
    "slotTexturePath": "/fallback/cosmetics/crafting-table-slots/stone-cold.png",
    "creator": "Tantosy",
    "license": "MIT",
    "sourceUrl": "https://modrinth.com/resourcepack/glassyui",
    "tablePalette": {
      "surface": "#b5afaa",
      "edge": "#4a4848",
      "highlight": "#dad2be",
      "accent": "#a9cc9d",
      "label": "#231d18"
    }
  },
  {
    "id": "woody",
    "category": "crafting-table",
    "name": "Woody",
    "rarity": "starter",
    "coinPrice": 0,
    "slotTexturePath": "/fallback/cosmetics/crafting-table-slots/woody.png",
    "creator": "Devoneox",
    "license": "MIT",
    "sourceUrl": "https://modrinth.com/resourcepack/deep-origins-gui-overhaul",
    "tablePalette": {
      "surface": "#9b6336",
      "edge": "#402a1c",
      "highlight": "#cdab85",
      "accent": "#948d40",
      "label": "#f7f4ed"
    }
  },
  {
    "id": "challenger",
    "category": "crafting-table",
    "name": "Challenger",
    "rarity": "rare",
    "coinPrice": 500,
    "slotTexturePath": "/fallback/cosmetics/crafting-table-slots/challenger.png",
    "creator": "Voidcxster",
    "license": "MIT",
    "sourceUrl": "https://modrinth.com/resourcepack/voids-transparent-gui",
    "tablePalette": {
      "surface": "#685610",
      "edge": "#2d260e",
      "highlight": "#b4a572",
      "accent": "#6b8321",
      "label": "#f7f4ed"
    }
  },
  {
    "id": "horse-armor",
    "category": "crafting-table",
    "name": "Horse Armor",
    "rarity": "epic",
    "coinPrice": 750,
    "slotTexturePath": "/fallback/cosmetics/crafting-table-slots/horse-armor.png",
    "creator": "BizCub",
    "license": "MIT",
    "sourceUrl": "https://modrinth.com/resourcepack/better-gui",
    "tablePalette": {
      "surface": "#423c36",
      "edge": "#1e1c1c",
      "highlight": "#a09885",
      "accent": "#4c6e40",
      "label": "#f7f4ed"
    }
  },
  {
    "id": "gold",
    "category": "crafting-table",
    "name": "Gold",
    "rarity": "epic",
    "coinPrice": 750,
    "slotTexturePath": "/fallback/cosmetics/crafting-table-slots/gold.png",
    "creator": "itsquasi",
    "license": "MIT",
    "sourceUrl": "https://modrinth.com/resourcepack/gui-overhaul",
    "tablePalette": {
      "surface": "#352f2a",
      "edge": "#191717",
      "highlight": "#9a927e",
      "accent": "#416435",
      "label": "#f7f4ed"
    }
  },
  {
    "id": "salmon-glass",
    "category": "crafting-table",
    "name": "Salmon Glass",
    "rarity": "uncommon",
    "coinPrice": 250,
    "slotTexturePath": "/fallback/cosmetics/crafting-table-slots/salmon-glass.png",
    "creator": "itsquasi",
    "license": "MIT",
    "sourceUrl": "https://modrinth.com/resourcepack/gui-overhaul",
    "tablePalette": {
      "surface": "#8f6350",
      "edge": "#3b2a26",
      "highlight": "#c7ab92",
      "accent": "#8a8d55",
      "label": "#f7f4ed"
    }
  },
  {
    "id": "medieval-stone",
    "category": "crafting-table",
    "name": "Medieval Stone",
    "rarity": "uncommon",
    "coinPrice": 250,
    "slotTexturePath": "/fallback/cosmetics/crafting-table-slots/medieval-stone.png",
    "creator": "itsquasi",
    "license": "MIT",
    "sourceUrl": "https://modrinth.com/resourcepack/gui-overhaul",
    "tablePalette": {
      "surface": "#827c76",
      "edge": "#363434",
      "highlight": "#c0b8a5",
      "accent": "#80a274",
      "label": "#231d18"
    }
  }
]
